import { FormControl } from "@atoms"
import { Button, Checkbox, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { Controller, UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useExecutionMember, useMemberRespondents } from "../../queries"
import { useEventId, usePresenceId } from "pages/events"
import { IEditAccidentForm } from "."
import { BaseSyntheticEvent } from "react"

interface Props {
  form: UseFormReturn<IEditAccidentForm, any>
  onSubmit: (
    e?: BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>
  submitIsLoading: boolean
}

const WarnedPerson: React.FC<Props> = ({
  form: {
    formState: { errors },
    control,
  },
  onSubmit,
  submitIsLoading,
}) => {
  const { t } = useTranslation()

  const presenceId = usePresenceId()
  const eventId = useEventId()
  const member = useExecutionMember(eventId!, presenceId!)

  const respondents = useMemberRespondents(member.data?.member_id!, {
    enabled: member.isFetched,
  })

  return (
    <form>
      <FormControl>
        <Controller
          control={control}
          name="emergency"
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            >
              {t("accidents.emergency_services")}
            </Checkbox>
          )}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={control}
          name="emergency_comment"
          render={({ field }) => (
            <TextArea
              {...field}
              placeholder={t("accidents.emergency_services_note")}
            />
          )}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={control}
          name="respondent_id"
          render={({ field }) => {
            return (
              <Select
                loading={respondents.isLoading}
                options={respondents.data?.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                placeholder={t("members.respondents")}
                {...field}
              />
            )
          }}
        />
        {errors.respondent_id && (
          <FormControl.HelperText>
            {errors.respondent_id.message}
          </FormControl.HelperText>
        )}
      </FormControl>
      <FormControl>
        <Controller
          control={control}
          name="respondent_note"
          render={({ field }) => (
            <TextArea {...field} placeholder={t("accidents.respondent_note")} />
          )}
        />
      </FormControl>
      <Button loading={submitIsLoading} type="primary" onClick={onSubmit}>
        {t("global.save")}
      </Button>
    </form>
  )
}

export default WarnedPerson
